module.exports = __webpack_public_path__ + "img/02.3fb47c6e.jpg";